<template>
  <div>
    <div v-if="loading" class="text-center mt-7">
      <v-progress-circular indeterminate color="primary" size="60"> </v-progress-circular>
    </div>
    <template v-else>
      <div v-if="logData && logData.length > 0" class="mt-3">
        <v-expansion-panels accordion multiple>
          <v-expansion-panel readonly>
            <v-expansion-panel-header>
              <v-layout wrap>
                <v-flex xs6>
                  <span class="font-weight-bold">รายการ</span>
                </v-flex>
                <v-flex xs3 style="display: flex; align-items: center">
                  <span class="font-weight-bold">คะแนน</span>
                </v-flex>
                <v-flex xs3 style="display: flex; align-items: center">
                  <span class="font-weight-bold">คงเหลือ</span>
                </v-flex>
              </v-layout>
              <template v-slot:actions>
                <v-icon color="#FFF">
                  $expand
                </v-icon>
              </template>
            </v-expansion-panel-header>
          </v-expansion-panel>
          <v-expansion-panel v-for="(item, index) in logData" :key="index">
            <v-expansion-panel-header>
              <v-layout wrap>
                <v-flex xs6>
                  <div>{{ item.action }}</div>
                  <div class="caption">
                    {{ getFormattedDate(item.timestamp) }}
                  </div>
                </v-flex>
                <v-flex xs3 style="display: flex; align-items: center">
                  <span :class="item.update_point > 0 ? 'green--text' : 'red--text'">{{ item.update_point > 0 ? "+" : "" }}</span>
                  <span :class="item.update_point > 0 ? 'green--text' : 'red--text'">{{ numberFormat(item.update_point) }}</span>
                </v-flex>
                <v-flex xs3 style="display: flex; align-items: center">
                  <span>{{ numberFormat(item.point) }}</span>
                </v-flex>
              </v-layout>
              <template v-slot:actions>
                <v-icon :color="'primary'">
                  $expand
                </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="grey lighten-3 ">
              <div class="pt-4">
                <template v-if="item.action === 'สะสมคะแนน'">
                  <div>
                    เลขที่ใบเสร็จ:
                    {{ getNote(item.action, item.note).ref_no }}
                  </div>
                  <div>
                    วันที่ซื้อ:
                    {{ getNote(item.action, item.note).order_date }}
                  </div>
                  <div>
                    ยอดซื้อสุทธิ:
                    {{ numberFormat(getNote(item.action, item.note).total_purchase) }}
                  </div>
                </template>
                <template v-else>
                  {{ getNote(item.action, item.note) }}
                </template>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div v-else style="color: darkgrey; font-size: 24px" class="mt-7 text-center">
        ยังไม่มีรายการเดินคะแนนสะสม
      </div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import numeral from "numeral";

export default {
  data() {
    return {
      logData: [],
      limit: 100,
      offset: 0,
      total: 0,
      loading: false,
    };
  },
  mounted() {
    this.handleGetLogPoint();
  },
  computed: {
    moment() {
      return moment;
    },
  },
  methods: {
    async handleGetLogPoint() {
      const vm = this;
      try {
        const memberId = vm.$store.state.member.memberId;
        const pageId = vm.query.pageid;

        vm.loading = true;
        const url = `${vm.serverUrl}toa-crm/transaction-point/${pageId}/${memberId}`;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer liff n266rva2jzvbv4vzdkurb" },
          params: {
            limit: vm.limit,
            offset: vm.offset,
          },
        });
        vm.loading = false;

        if (response && response.status === 200) {
          vm.logData = response.data.data;
          vm.total = response.data.total;
        }
      } catch (error) {
        console.error(error);
      }
    },
    isShowDetails(action) {
      let status = false;

      if (action === "คะแนนสะสมพิเศษ" || action === "แลกของรางวัล") {
        status = true;
      }
      return status;
    },
    getNote(action, note) {
      let tempNote = "";
      if (note) {
        let obj = {};
        try {
          obj = JSON.parse(note);
        } catch (error) {
          console.log(note);
        }
        const foundKey = Object.keys(obj);

        if (action === "สะสมคะแนน") {
          const orderDate = obj?.rawData?.date ? moment(obj.rawData.date).format("DD/MM/YYYY") : "-";
          const tempData = {
            ref_no: obj?.rawData?.ref_no ? obj.rawData.ref_no : "-",
            order_date: orderDate,
            // total_purchase: obj?.rawData?.products ? obj.rawData.products.reduce((prev, cur) => parseFloat(prev.price) + parseFloat(cur.price)) : "-",
            total_purchase: obj?.sum_point ? obj.sum_point : "-",
          };
          tempNote = tempData;
        } else {
          if ([...foundKey].includes("camapignName")) {
            tempNote = `ชื่อแคมเปญ: ${obj.camapignName}`;
          } else if ([...foundKey].includes("data")) {
            tempNote = `เลขที่ใบเสร็จ: ${obj.data[0].ref_no}`;
          } else if ([...foundKey].includes("ref_no")) {
            tempNote = `เลขที่ใบเสร็จ: ${obj.ref_no}`;
          } else {
            tempNote = `ของรางวัล: ${obj.name}`;
          }
        }
      }
      return tempNote;
    },
    getFormattedDate(val) {
      return val ? moment(val).format("DD/MM/YYYY HH:mm") : "";
    },
    numberFormat(val) {
      return val ? numeral(val).format("0,0") : "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
